import React from "react";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { InfoBox } from "./InfoBox";
const data = [{
  day: "Pzt",
  hours: 6
}, {
  day: "Sal",
  hours: 5
}, {
  day: "Çar",
  hours: 7
}, {
  day: "Per",
  hours: 4
}, {
  day: "Cum",
  hours: 8
}, {
  day: "Cmt",
  hours: 3
}, {
  day: "Paz",
  hours: 2
}];
export function WeeklyStats() {
  const todayHours = 8; // Today's study hours
  return <div className="space-y-6 mb-6" data-id="element-1379">
      <InfoBox title="Günlük Çalışma İstatistiği" value={`${todayHours} saat`} description="Bugünkü toplam çalışma süreniz" gradientFrom="from-purple-600" gradientTo="to-blue-600" data-id="element-1380" />
      <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-1381">
        <div className="relative p-4 sm:p-6 bg-black/90 rounded-lg" data-id="element-1382">
          <h3 className="text-gray-400 font-medium text-sm mb-4" data-id="element-1383">
            Haftalık Çalışma Grafiği
          </h3>
          <div className="h-[200px] sm:h-[250px] w-full flex items-center justify-center" data-id="element-1384">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1385">
              <AreaChart data={data} margin={{
              top: 5,
              right: 5,
              left: -20,
              bottom: 5
            }} data-id="element-1386">
                <XAxis dataKey="day" stroke="#9CA3AF" tick={{
                fontSize: 12
              }} tickMargin={10} data-id="element-1387" />
                <YAxis stroke="#9CA3AF" domain={[0, 24]} ticks={[0, 4, 8, 12, 16, 20, 24]} tick={{
                fontSize: 12
              }} data-id="element-1388" />
                <Tooltip formatter={value => [`${value} saat`, "Çalışma Süresi"]} contentStyle={{
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                border: "1px solid rgba(147, 51, 234, 0.5)",
                borderRadius: "0.5rem"
              }} labelStyle={{
                color: "#9CA3AF"
              }} data-id="element-1389" />
                <Area type="monotone" dataKey="hours" stroke="#A78BFA" fill="#A78BFA33" strokeWidth={2} data-id="element-1390" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>;
}